/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.passes',
  'acme.common.factory.notice',
  'acme.view.application.passes.create.modals.publish.controllers',
  'acme.view.application.passes.create.modals.cancel.controllers',
  'acme.view.application.passes.create.modals.remove.controllers'
])

.controller('PassesCreateController', ['$scope', '$state', '$location', '$timeout', '$uibModal', 'ApiService', 'HelpersService', 'ValidateService', 'PassesService', 'NoticeFactory', function($scope, $state, $location, $timeout, $uibModal, ApiService, HelpersService, ValidateService, PassesService, NoticeFactory) {

    $scope.passesCreate = {

      model: {},

      mode: 'create',
      tabErrors: {},
      publishDate: false,
      draftDate: false,

      isSaving: false,
      isUpdating: false,
      isPublishing: false,
      isSubmitted: false,

      validators: [],

      cap: HelpersService.cap,

      notice: new NoticeFactory(),

      init: function() {

        var titleBar = {};

        ValidateService.errors = [];

        this.initValidators();

        this.clearTabErrors();

        if ($state.params) {
          if ($state.params.id) {
            this.mode = 'edit';
            this.getPassTemplate($state.params.id);
          }else{
            PassesService.resetModel(this.model);
            this.model = PassesService.getModel();
            $timeout(function() {
              $scope.$broadcast('PassesCreateController::UpdateModel');
            }, 0);

            if (this.model.state === 'draft') {
              titleBar.buttonRight = {
                label: this.isMode('edit') ? 'Save' : 'Create',
                permissions: 'PASS_RANGES_VIEW',
                action: function () {
                  $scope.passesCreate.save(false, true);
                }
              };
            }

          }
        }

        titleBar.title = HelpersService.cap(this.mode) + ' Pass Program';

        titleBar.buttonLeft = {
          label: 'Cancel',
          permissions: 'PASS_RANGES_VIEW',
          action: function() {
            $scope.passesCreate.cancel();
          }
        };

        $scope.$emit('Application::contentTitleChange', titleBar);
        $scope.$on('PassesCreateController::TabCheck', this.onTabCheck);
        $scope.$on('$destroy', $scope.$watch('passesCreate.model.characters', this.onCharactersUpdate));

      },

      initValidators: function() {
        this.validators = [
          {
            field: 'passes-header-name',
            len: {
              message: 'The name must not be empty',
              test: function() {
                var self = $scope.passesCreate;
                return {
                  value: self.model.name
                };
              }
            }
          },
          {
            field: 'passes-series-length',
            greater: {
              message: 'You must have at least one series',
              test: function() {
                var self = $scope.passesCreate;
                return {
                  greater: (self.model.series instanceof Array) ? self.model.series.length : 0,
                  less: 0
                };
              }
            }
          }
        ];
      },

      getPassTemplate: function(id) {
        ApiService.passes.detail({ id: id }).then(this.success.getPassTemplate, this.error.getPassTemplate);
      },

      getError: function(field) {
        return ValidateService.getError(field);
      },

      isState: function (path) {

        var location = $location.path();

        return (location.indexOf(path) !== -1);

      },

      isMode: function (mode) {
        return (this.mode === mode);
      },

      getState: function (name) {
        var stateName = 'application.passes',
          stateParams = {};

        if (this.mode === 'create') {
          stateName += '.create.'+name;
        }else{
          stateName += '.edit.'+name;
          stateParams.id = $state.params.id;
        }

        if (this.isMode('create')) {
          $state.go(stateName, stateParams);
        }else{
          this.save(false, true, {
            name: stateName,
            stateParams: stateParams
          });
        }
      },

      cancel: function() {
        $state.go('application.passes.list');
      },

      cancelProgram: function() {

        var name = this.model.name,
            characters = this.model.characters;

        this.model = PassesService.getConfig();
        this.model.name = name;
        this.model.characters = characters;
        this.model.state = 'cancelled';
        ApiService.passes.update(this.model).then(this.success.cancelProgram, this.error.cancelProgram);

      },

      remove: function() {
        ApiService.passes.remove({ id: this.model.id }).then(this.success.remove, this.error.remove);
      },

      publish: function() {
        var self = $scope.passesCreate;

        this.isPublishing = true;

        $scope.$broadcast('PassesCreateController::Save');

        $timeout(function() {
          self.model = PassesService.getConfig();

          if (!self.hasTabErrors('series') &&
              ValidateService.validate(self.validators) &&
              ValidateService.errors.length === 0) {
            self.showPublishNotification();
          }else if (self.hasTabErrors('series')) {
            self.isPublishing = false;
          }else if (ValidateService.errors.length) {
            self.isPublishing = false;
            self.notice.showErrorMessages([{
              message: ValidateService.errors[0].message
            }]);
          }
        }, 0);

      },

      save: function (publish, update, state, silent) {
        var self = $scope.passesCreate,
            name = this.model.name,
            characters = this.model.characters;

        this.isUpdate = (update);
        this.isSaving = true;
        this.isSubmitted = true;
        // Trigger save event downstream to subviews
        if (!silent) {
          $scope.$broadcast('PassesCreateController::Save');
        }

        this.notice.hideSuccessMessages();

        //next tick
        $timeout(function() {
          self.model = PassesService.getConfig();
          self.model.name = name;
          self.model.characters = characters;

          if (!self.hasTabErrors('series') && ValidateService.validate(self.validators) && (!publish || (publish && ValidateService.errors.length === 0))) {
            self.notice.hideErrorMessages();

            if (self.isMode('edit')) {
              if (publish) {
                self.isPublishing = true;
                self.model.state = 'published';
                ApiService.passes.update(self.model).then(function(response) {
                  self.success.save(response);

                  if (state) {
                    $state.go(state.name);
                  }
                }, self.error.save);
              } else {
                ApiService.passes.update(self.model).then(function(response) {
                  self.success.save(response);
                  if (state) {
                    $state.go(state.name);
                  }
                }, self.error.save);
              }
            }else{
              ApiService.passes.create(self.model).then(function(response) {
                self.success.save(response);

                $state.go('application.passes.edit.series', { id: response.data.payload.id });
              }, self.error.save);
            }
          } else if (state) {
            $state.go(state.name);
            self.isSaving = false;
            self.isSubmitted = false;
            self.isUpdate = false;
            self.isPublishing = false;
          } else {
            self.isSaving = false;
            self.isSubmitted = false;
            self.isUpdate = false;
            self.isPublishing = false;
            if (ValidateService.errors.length) {
              self.notice.showErrorMessages([{
                message: ValidateService.errors[0].message
              }]);
            }
          }
        }, 100);
      },

      hasTabErrors: function(tab) {
        return (this.tabErrors[tab]);
      },

      clearTabErrors: function() {
        var error;

        for (error in this.tabErrors) {
          if (this.tabErrors.hasOwnProperty(error)) {
            this.tabErrors[error] = false;
          }
        }
      },

      showRemoveNotification: function () {
        var self = $scope.passesCreate;

        self.modalDialog = $uibModal.open( {
          templateUrl: 'views/application/views/passes/create/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'PassesCreateModalsRemoveController',
          resolve: {
            pass: function() {
              return PassesService.getConfig();
            }
          }
        });

        self.modalDialog.result.then( function() {
          self.remove();
        }, function() {
          // do nothing
        });
      },

      showCancelNotification: function () {
        var self = $scope.passesCreate;

        self.modalDialog = $uibModal.open( {
          templateUrl: 'views/application/views/passes/create/modals/cancel/cancel.tpl.html',
          size: 'md',
          controller: 'PassesCreateModalsCancelController',
          resolve: {
            pass: function() {
              return PassesService.getConfig();
            }
          }
        });

        self.modalDialog.result.then( function() {
          self.cancelProgram();
        }, function() {
          // do nothing
        });
      },

      showPublishNotification: function () {
        var self = $scope.passesCreate;

        self.modalDialog = $uibModal.open( {
          templateUrl: 'views/application/views/passes/create/modals/publish/publish.tpl.html',
          size: 'md',
          controller: 'PassesCreateModalsPublishController',
          resolve: {
            pass: function() {
              return PassesService.getConfig();
            }
          }
        });

        self.modalDialog.result.then( function() {
          self.save(true, true, { name: 'application.passes.list' });
        }, function() {
          // do nothing
        });
      },

      success: {
        init: function(response) {},
        save: function(response) {
          var self = $scope.passesCreate;

          self.isSaving = false;
          self.isPublishing = false;

          $timeout(function() {
            $scope.$broadcast('PassesCreateController::UpdateModel');
          }, 0);

        },
        remove: function(response) {
          $state.go('application.passes.list');
        },
        getPassTemplate: function(response) {

          var titleBar = {},
              self = $scope.passesCreate;

          PassesService.setModel(response.data.payload);
          self.model = PassesService.getModel();
          // next tick
          $timeout(function() {
            $scope.$broadcast('PassesCreateController::UpdateModel');
          }, 0);

          titleBar.title = HelpersService.cap(self.mode) + ' Pass Program';

          if (self.model.state !== 'published') {
            titleBar.buttonRight = {
              label: self.isMode('edit') ? 'Save' : 'Create',
              permissions: 'PASS_RANGES_VIEW',
              action: function () {
                $scope.passesCreate.save(false, true);
              }
            };
          }

          titleBar.buttonLeft = {
            label: 'Cancel',
            permissions: 'PASS_RANGES_VIEW',
            action: function() {
              $scope.passesCreate.cancel();
            }
          };

          $scope.$emit('Application::contentTitleChange', titleBar);
        },
        cancelProgram: function(response) {
          $state.go('application.passes.list');
        }
      },

      error: {
        init: function(response) {},
        generic: function(response) {
          var self = $scope.passesCreate;
          self.isSaving = false;
          self.isPublishing = false;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        save: function(response) {
          $scope.passesCreate.error.generic(response);
        },
        remove: function(response) {
          $scope.passesCreate.error.generic(response);
        },
        getPassTemplate: function(response) {
          $scope.passesCreate.error.generic(response);
        },
        cancelProgram: function(response) {
          $scope.passesCreate.error.generic(response);
        }
      },

      onTabCheck: function(e, data) {
        var self = $scope.passesCreate;

        self.tabErrors[data.tab] = (data.invalid);

        if (self.tabErrors[data.tab]) {
          self.notice.showErrorMessages([{
            message: (data.message) ? data.message : 'Please correct errors below.'
          }]);
        }else{
          self.notice.hideErrorMessages();
        }

      },

      onCharactersUpdate: function(n, o) {
        if (n !== o) {
          PassesService.model.characters = n;
          $scope.$broadcast('PassesCreateController::CharactersUpdate');
        }
      }

    };

    $scope.passesCreate.init();

}]);